import * as React from 'react';

import type { CmlContent } from '__generated__/graphql-types';

import { CML, toPlainText } from 'bundles/cml';
import HelpCenterInfo from 'bundles/unified-common/components/HelpCenterInfo';
import type { FaqModuleItem } from 'bundles/unified-common/modules/FAQsModule';
import FAQsModule from 'bundles/unified-common/modules/FAQsModule';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import convertToCmlContent from 'bundles/unified-description-page-common/utils/convertToCmlContent';
import getProjectPageFaqs from 'bundles/unified-description-page-common/utils/getProjectPageFaqs';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment;
};

const ProjectFAQsModuleRenderer = ({ pageData }: Props) => {
  if (!pageData.courseType) {
    return null;
  }

  const faqs = getProjectPageFaqs(pageData.courseType, !!pageData.hasFullDiscount);

  const convertedFaqs = faqs.map((faq): FaqModuleItem => {
    return {
      question: toPlainText(convertToCmlContent(faq.question as CmlContent)) || '',
      answer: <CML cml={faq.answer as CmlContent} />,
    };
  });

  return <FAQsModule faqs={convertedFaqs} moreInfo={<HelpCenterInfo />} />;
};

export default ProjectFAQsModuleRenderer;
